import { StatusCodes } from 'http-status-codes';
import { CategoryRecommendation } from '@/client/types/categoryRecommendation';

const TIMEOUT = 1000;

type CategoryUrlResult = {
  url: string;
  category: CategoryRecommendation;
};

const getCategoryRecommendationUrl = async (searchQuery: string): Promise<CategoryUrlResult | null> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), TIMEOUT);

  try {
    const params = new URLSearchParams({
      query: searchQuery,
    });

    const response = await fetch(`/lrp/api/category-recommendation?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (response.status === StatusCodes.NO_CONTENT) {
      return null;
    }

    if (!response.ok) {
      return null;
    }

    const category: CategoryRecommendation = await response.json();

    if (!category || !category.l1?.categoryId || !category.l1?.key) {
      return null;
    }

    const l1Key = category.l1.key;

    let url: string;

    if (category.l2?.categoryId && category.l2?.key) {
      const l2Key = category.l2.key;
      url = `/l/${l1Key}/${l2Key}/#q:${encodeURIComponent(searchQuery)}`;
    } else {
      url = `/l/${l1Key}/#q:${encodeURIComponent(searchQuery)}`;
    }
    return { url, category };
  } catch {
    clearTimeout(timeoutId);
    return null;
  }
};
export default getCategoryRecommendationUrl;
